import {get, post} from "@/config/api";

const state = {
};

const getters = {
};

const mutations = {
};

const actions = {
  DoItemAction({}, params) {
    return new Promise((resolve, reject) => {
      post("action/user/item/", params).then((data) => {
        resolve(data)
      }, (err)=> {
        reject(err)
      })
    })
  },

  DoItemActionStats({}, params) {
    return new Promise((resolve, reject) => {
      post("action/user/item_stats/", params).then((data) => {
        resolve(data)
      }, (err)=> {
        reject(err)
      })
    })
  },

  GetFeedItemList({}, params) {
    return new Promise((resolve, reject) => {
      get(`feed/item/list/`, params).then((data) => {
        resolve(data);
      }, (error) => {
        reject(error)
      })
    });
  },

  GetFeedItemListV2({}, params) {
    return new Promise((resolve, reject) => {
      get(`v2/feed/item/list/`, params).then((data) => {
        resolve(data);
      }, (error) => {
        reject(error)
      })
    });
  },

  SearchItems({}, params) {
    return new Promise((resolve, reject) => {
      get("/search/items/", params).then((data) => {
        resolve(data)
      }, (err)=> {
        reject(err)
      })
    })
  },

  GetRelatedItem({}, params) {
    return new Promise((resolve, reject) => {
      get("/look/related", params).then((data) => {
        resolve(data)
      }, (err)=> {
        reject(err)
      })
    })
  },

  GetUserAlbumItems({}, params) {
    return new Promise((resolve, reject) => {
      get("feed/item/user_album/", params).then((data) => {
        resolve(data)
      }, (err)=> {
        reject(err)
      })
    })
  },

  UpdateItemStatus({}, params) {
    return new Promise((resolve, reject) => {
      post(`ugc/item/status/update/`, params).then((data) => {
        resolve(data);
      }, (error) => {
        reject(error)
      })
    });
  }

};

export default {
  state,
  getters,
  actions,
  mutations,
};
